import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import { ProductInfo } from '../../../../app/shared/models/b2b/productInfo';
import { Stock } from '../../../../app/shared/models/b2b/stock';
import { Product } from '../../../../app/shared/models/b2b/product';
import { Base64, isViewportMobile } from '../../../../app/shared/lib/helpers/utils';

declare var Flickity: any;

@Component({
    selector: 'app-product-extended-info',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-extended-info.component.html'
})
export class ProductExtendedInfoComponent implements OnInit, OnChanges, OnDestroy {
    @Input() item: Product = null;
    @Input() productMoreInfo: ProductInfo;
    @Input() productMoreImagesBig: any[];
    @Input() productMoreImagesSmall: any[];
    @Input() checkMoreImagesBig: boolean = false;
    @Input() productStock: Stock[];
    @Input() empresa: number;
    @Output() clickCloseExtendInfo: EventEmitter<void> = new EventEmitter();

    viewportMobile: boolean = isViewportMobile();

    // Carousels
    flkty: any;
    flktyNav: any;
    flktyReady: boolean = false;
    flktyNavReady: boolean = false;
    isfullscreen: boolean;
    initNavCarousel: boolean;
    flickityInitTimeout: ReturnType<typeof setTimeout> = null;
    flickityInitRetries: number = 0;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.flktyReady = false;
        this.flktyNavReady = false;
    }

    ngOnDestroy(): void {
        this.clearFlickityInitTimeout();
        this.destroyFlickity();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.productMoreInfo) {
            this.productMoreInfo = changes.productMoreInfo.currentValue;
        }
        if (changes && changes.productMoreImagesBig) {
            this.productMoreImagesBig = changes.productMoreImagesBig.currentValue;
            if (this.productMoreImagesBig && this.productMoreImagesBig.length) {
                this.scheduleFlickityInit();
            } else {
                this.clearFlickityInitTimeout();
                this.destroyFlickity();
            }
        }
        if (changes && changes.productMoreImagesSmall) {
            this.productMoreImagesSmall = changes.productMoreImagesSmall.currentValue;
        }
        if (changes && changes.checkMoreImagesBig) {
            this.checkMoreImagesBig = changes.checkMoreImagesBig.currentValue;
        }
        if (changes && changes.productStock) {
            this.productStock = changes.productStock.currentValue;
        }
        if (changes && changes.empresa) {
            this.empresa = changes.empresa.currentValue;
        }
    }

    onClickCloseExtendInfo() {
        this.clickCloseExtendInfo.emit();
    }

    private scheduleFlickityInit(): void {
        const galleryWrapper = document.querySelector('#product-gallery-wrapper');
        galleryWrapper?.classList.remove('opacity-100');
        galleryWrapper?.classList.add('opacity-0');

        this.clearFlickityInitTimeout();
        this.flickityInitRetries = 0;
        this.tryInitFlickity();
    }

    private tryInitFlickity(): void {
        const carouselCell = document.querySelector('#carousel-product-main .js-carousel-cell');

        if (carouselCell) {
            this.initFlickity();
            return;
        }

        if (this.flickityInitRetries >= 50) {
            return;
        }

        this.flickityInitRetries += 1;
        this.flickityInitTimeout = setTimeout(() => this.tryInitFlickity(), 20);
    }

    private clearFlickityInitTimeout(): void {
        if (this.flickityInitTimeout) {
            clearTimeout(this.flickityInitTimeout);
            this.flickityInitTimeout = null;
        }
    }

    showOldLabel(item: any): boolean {
        return (
            item.info.veretiquetado &&
            (item.info.onda === '' ||
                item.info.onda === '0' ||
                item.info.onda === '1' ||
                item.info.onda === '2' ||
                item.info.onda === '3')
        );
    }

    showNewLabel(item: any): boolean {
        return item.info.veretiquetado && (item.info.onda === 'A' || item.info.onda === 'B' || item.info.onda === 'C');
    }

    getPrintLabelUrl(item: Product): string {
        const nombre = encodeURIComponent(Base64.encode(item.info.nombre.trim()));
        const qr =
            item.info.codigoqr.trim() !== '' ? encodeURIComponent(Base64.encode(item.info.codigoqr.trim())) : '-';
        const marca = encodeURIComponent(item.info.marca.trim());
        let url = '';
        if (
            item.info.onda === '' ||
            item.info.onda === '0' ||
            item.info.onda === '1' ||
            item.info.onda === '2' ||
            item.info.onda === '3'
        ) {
            url =
                'product-print/' +
                encodeURIComponent(item.info.agarre.trim()) +
                '/' +
                encodeURIComponent(item.info.consumo.trim()) +
                '/' +
                encodeURIComponent(item.info.ruido.trim()) +
                '/' +
                encodeURIComponent(item.info.etiquetado2.trim()) +
                '/' +
                marca +
                '/' +
                nombre;
        } else if (item.info.onda === 'A' || item.info.onda === 'B' || item.info.onda === 'C') {
            url =
                'product-print-new/' +
                encodeURIComponent(item.info.carga.trim()) +
                '/' +
                encodeURIComponent(item.info.velocidad.trim()) +
                '/' +
                encodeURIComponent(item.info.referenciaProveedor.trim()) +
                '/' +
                encodeURIComponent(item.info.ancho.trim()) +
                '/' +
                encodeURIComponent(item.info.perfil.trim()) +
                '/' +
                encodeURIComponent(item.info.llanta.trim()) +
                '/' +
                encodeURIComponent(item.info.agarre.trim()) +
                '/' +
                encodeURIComponent(item.info.consumo.trim()) +
                '/' +
                encodeURIComponent(item.info.ruido.trim()) +
                '/' +
                encodeURIComponent(item.info.etiquetado2.trim()) +
                '/' +
                marca +
                '/' +
                encodeURIComponent(item.info.onda.trim()) +
                '/' +
                (item.info.hielo ? 1 : 0) +
                '/' +
                (item.info.nieve ? 1 : 0) +
                '/' +
                qr +
                '/' +
                nombre;
        }
        return url.replace('%2F', '--');
    }

    initFlickity() {
        this.destroyFlickity();

        const _ref = this;

        this.initNavCarousel = true;

        const initMainConf = {
            on: {
                ready: function () {
                    _ref.flktyReady = true;
                    const galleryWrapper = document.querySelector('#product-gallery-wrapper');
                    galleryWrapper?.classList.remove('opacity-0');
                    galleryWrapper?.classList.add('opacity-100');
                }
            },
            cellSelector: '.js-carousel-cell',
            imagesLoaded: true,
            fullscreen: true,
            lazyLoad: 1,
            prevNextButtons: true,
            pageDots: false,
            draggable: this.viewportMobile
        };

        // Si sólo hay una imagen quitamos los botones y dots de navegación
        if (this.productMoreImagesBig && this.productMoreImagesBig.length < 2) {
            initMainConf.prevNextButtons = false;
            initMainConf.pageDots = false;
        }

        this.flkty = new Flickity('#carousel-product-main', initMainConf);

        // Inicialización del carrusel de navegación si hay más de una imagen
        if (this.productMoreImagesSmall && this.productMoreImagesSmall.length > 1) {
            const initNavConf = {
                on: {
                    ready: function () {
                        _ref.flktyNavReady = true;
                    }
                },
                cellSelector: '.js-carousel-cell',
                imagesLoaded: true,
                asNavFor: '#carousel-product-main',
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                draggable: true
            };

            // Si hay menos de 4 imágenes pequeñas quitamos las flechas de navegación
            if (this.productMoreImagesSmall.length < 4) {
                initNavConf.prevNextButtons = false;
            }

            this.flktyNav = new Flickity('#carousel-product-nav', initNavConf);
        } else {
            this.initNavCarousel = false;
        }

        // this.flkty.on('change', function (index) {
        //     console.log('Slide changed to ' + index);
        // });

        this.flkty.on('fullscreenChange', function (isFullscreen) {
            _ref.isfullscreen = isFullscreen;
            _ref.cdr.detectChanges();
        });
    }

    viewFullscreen() {
        if (!this.isfullscreen) {
            this.flkty.viewFullscreen();
        }
    }

    exitFullscreen() {
        if (this.isfullscreen) {
            this.flkty.exitFullscreen();
        }
    }

    destroyFlickity() {
        if (this.flkty) {
            this.flktyReady = false;
            this.flkty.destroy();
            this.flkty = null;
        }

        if (this.flktyNav) {
            this.flktyNavReady = false;
            this.flktyNav.destroy();
            this.flktyNav = null;
        }
    }
}
